import {
  Button,
  Container,
  isWeb,
  shadowStandard,
  SizableText,
  SmartLink,
  Stack,
  XStack,
  YStack,
  CarouselButtons,
  useCarousel,
} from '@my/ui'

import { SectionTitle } from 'app/components'

import { OfferCardContent } from '../featured-offers-block/components/offer-card-content'
import { FlatList } from 'react-native'

export const ForYouComponent = (block) => {
  const carousel = useCarousel()

  const basicCardWrapper = {
    w: 150,
    h: 200,
    $gtXs: {
      w: 286,
      h: 390,
    },
  }

  return (
    <Container size="xl">
      <XStack alignItems="center" justifyContent="space-between" pb="$4">
        <SectionTitle>For You</SectionTitle>
        <SmartLink Component={Button} href="/brands" size="$3" fontWeight="500" theme="gray">
          Discover Brands
        </SmartLink>
      </XStack>
      <Stack>
        {isWeb ? (
          <Stack position="relative" overflow="hidden" w="100%" ref={carousel.emblaRef as any}>
            <XStack gap="$4" height="auto">
              <Stack {...basicCardWrapper}>
                <FreeCard />
              </Stack>
              {block.offers &&
                block.offers.map((item) => (
                  <Stack key={item.id} {...basicCardWrapper}>
                    <OfferCardContent
                      offer={item}
                      showEndTime={false}
                      complexView={false}
                      withBackgroundImage={false}
                      imagePriority={block.imagePriority}
                    />
                  </Stack>
                ))}
            </XStack>
            <CarouselButtons carousel={carousel} />
          </Stack>
        ) : (
          <YStack flex={1} height="100%" m="$-2">
            <FlatList
              decelerationRate="normal"
              data={[{ offer: '' }, ...block.offers]}
              horizontal
              renderItem={({ item, index }) => {
                if (index === 0) {
                  return (
                    <Stack p="$2" {...basicCardWrapper}>
                      <FreeCard />
                    </Stack>
                  )
                }
                return (
                  <Stack p="$2" {...basicCardWrapper}>
                    <OfferCardContent
                      offer={item}
                      showEndTime={false}
                      complexView={false}
                      withBackgroundImage={false}
                      imagePriority={block.imagePriority}
                    />
                  </Stack>
                )
              }}
            />
          </YStack>
        )}
      </Stack>
    </Container>
  )
}

const FreeCard = () => {
  return (
    <YStack
      flex={1}
      p={8}
      jc="center"
      ai="center"
      br="$3"
      backgroundColor="$black"
      gap="$2"
      $gtXs={{
        p: '$3.5',
        gap: '$3.5',
      }}
      {...shadowStandard}
    >
      <SizableText
        textAlign="center"
        size="$3"
        fontWeight="600"
        color="$white"
        $gtXs={{
          lineHeight: 34,
          fontSize: 30,
          fow: '600',
        }}
      >
        Find the Brands you love
      </SizableText>

      <SizableText
        fontSize={10}
        lineHeight={14}
        textAlign="center"
        color="$white"
        $gtXs={{
          fontSize: '$4',
          lineHeight: '$5',
        }}
      >
        Join your favourite brands to view the latest offers, giveaways and exclusive content.
      </SizableText>

      <SmartLink
        Component={Button}
        theme="primary"
        href="/brands"
        size="$1"
        fontWeight="500"
        h={34}
        w="100%"
        br="$3"
        $gtXs={{
          size: '$4',
          fontWeight: '500',
        }}
      >
        Discover Brands
      </SmartLink>
    </YStack>
  )
}
